import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { ROUTE_INVITATIONS, ROUTE_THINK_SEED_CREATION } from 'constants/urls';
import { STATUS_SUCCESS, STATUS_FAILURE } from 'constants/status';
import NoThinkChatsImg from 'assets/images/think/no_think_chats.svg';
import ThemeTableCard from 'components/Cards/ThemeTableCard';
import InvitationCard from 'components/Cards/InvitationCard';
import SimpleCarousel from 'components/SimpleCarousel';
import Countdown from 'components/Countdown';
import Avatar from 'components/Avatar';
import { getThinkSeed, joinThemeTable } from 'modules/think-seeds/actions';
import { THINK } from 'constants/layout';
import { THINK_SEED } from 'constants/types';
import { STATUS_DEAD } from 'constants/tables';
import {
  ThinkSection, ThinkContent, TabContent, ButtonViewDetail, ThemeTableOverflow,
  NoContentWrapper, ThemeTableWrapper, ThemeTableDetails, AddButton, LastMessageWrapper, CreateTable,
} from './styles';

function Think(props) {
  const setBreadcrumbF = () => {
    const {
      literals, setBreadcrumb, resetContext,
    } = props;

    const breadcrumb = [
      {
        color: '#ffffff',
        text: literals.title,
      },
    ];

    setBreadcrumb(breadcrumb.slice());
    resetContext();
  };

  const [invitations, setInvitations] = useState([]);
  const { invitationsList } = props;

  useEffect(() => {
    setInvitations(invitationsList);
  }, [invitationsList]);

  useEffect(() => {
    const {
      getInvitations, setSectionSelected, resetAll, getAdditionalThinks,
    } = props;
    getAdditionalThinks();
    getInvitations();
    resetAll();
    setBreadcrumbF();
    setSectionSelected(THINK);
  }, []);

  const handleClickTable = (event) => {
    const { history } = props;
    const id = parseInt(event.currentTarget.getAttribute('data-id'), 10);
    history.push(`theme-table/${id}`);
  };

  const handleGoToInvitations = () => {
    const { history } = props;

    history.push(ROUTE_INVITATIONS);
  };

  const joinToTable = (id) => {
    const { history } = props;

    getThinkSeed(id).then((response) => {
      joinThemeTable(response).then(() => {
        history.push(`theme-table/${id}`);
      });
    });
  };

  const doNothing = () => {};

  const createTable = () => {
    const { history } = props;
    history.push(ROUTE_THINK_SEED_CREATION);
  };

  const printMyTables = () => {
    const {
      literals, myThinkChatsStatus, myThinkChatsList, app, user,
    } = props;

    const today = Math.floor(Date.now() / 1000);

    let content = null;
    switch (myThinkChatsStatus) {
      case STATUS_SUCCESS: {
        const tablesList = [...myThinkChatsList];
        tablesList.sort((a, b) => {
          if (a.status.id === STATUS_DEAD && b.status.id !== STATUS_DEAD) {
            return 1;
          }

          if (a.status.id !== STATUS_DEAD && b.status.id === STATUS_DEAD) {
            return -1;
          }

          if (a.last_message && !b.last_message) {
            return -1;
          }

          if (!a.last_message && b.last_message) {
            return 1;
          }

          if (a.last_message && b.last_message) {
            return a.last_message.timestamp > b.last_message.timestamp ? -1 : 1;
          }

          if (a.limit_date && b.limit_date) {
            if (a.limit_date > today && b.limit_date > today) {
              return a.limit_date < b.limit_date ? -1 : 1;
            }

            if (a.limit_date <= today) {
              return 1;
            }

            if (b.limit_date <= today) {
              return -1;
            }
          }

          return a.timestamp > b.timestamp ? -1 : 1;
        });
        const tables = _.map(tablesList, (item) => {
          const hasMessage = item.last_message && item.last_message.type && item.last_message.type.value === 'Message';
          const { last_message: lastMessage } = item;
          const avatar = hasMessage ? lastMessage.user.avatar : null;
          return (
            <ThemeTableOverflow key={item.id}>
              <ThemeTableWrapper onClick={handleClickTable} data-id={item.id} dead={item.status.id === STATUS_DEAD}>
                <ThemeTableCard onClick={doNothing} data={item} key={item.id} app={app} user={user} hideInfo />
                <ThemeTableDetails>
                  {item.status.id === STATUS_DEAD ? (
                    <div className='time'>
                      {literals.killed}
                    </div>
                  ) : null}
                  {item.status.id !== STATUS_DEAD && item.limit_date > today ? (
                    <div className='time'>
                      {literals.ending}
                      <Countdown time={item.limit_date} />
                    </div>
                  ) : null}
                  <div className='name'>{item.name}</div>
                </ThemeTableDetails>
                <div className='separator' />
                <div className='buttons_right'>
                  {!hasMessage && <ButtonViewDetail>{literals.viewTableDetail}</ButtonViewDetail>}
                  {hasMessage && (
                    <LastMessageWrapper>
                      <div className='avatar'>
                        <Avatar size={40} avatar={avatar} position='relative' />
                      </div>
                      <div className='text'>{lastMessage.text}</div>
                    </LastMessageWrapper>
                  )}
                </div>
              </ThemeTableWrapper>
            </ThemeTableOverflow>
          );
        });

        content = (
          <React.Fragment>
            {tables}
          </React.Fragment>
        );
        break;
      }
      case STATUS_FAILURE: {
        content = (<div className='errorMsg'>{literals.errorLoadingThinkChats}</div>);
        break;
      }
      default: {
        break;
      }
    }
    return (
      <React.Fragment>
        {content}
      </React.Fragment>
    );
  };

  const printInvitations = () => {
    const a = _.map(invitations, (invitation) => {
      return (
        <InvitationCard
          name={`${invitation.invited_by.firstname} ${invitation.invited_by.lastname}`}
          avatar={invitation.invited_by.avatar}
          table={invitation.think_seed.name}
          id={invitation.id}
          type={THINK_SEED}
          thinkSeedId={invitation.think_seed.id}
          invitation={invitation}
          joinToTable={joinToTable}
          key={invitation.id}
        />
      );
    });
    return (
      <SimpleCarousel classesList='invitation_card' showAllAnswers>
        {a}
      </SimpleCarousel>
    );
  };

  const printContent = () => {
    const {
      app: { color1 }, literals,
    } = props;
    return (
      <ThinkSection color={color1}>
        <CreateTable>
          <AddButton onClick={createTable}>+</AddButton>
        </CreateTable>
        {invitations.length > 0 && (
          <ThinkContent className='section_wrapper'>
            <div className='title_section' dangerouslySetInnerHTML={{ __html: literals.yourInvitations }} />
            <TabContent>
              {printInvitations()}
            </TabContent>
          </ThinkContent>)
        }
        <ThinkContent className='section_wrapper'>
          <div className='title_section' dangerouslySetInnerHTML={{ __html: literals.ongoingChats }} />
          <TabContent flex>
            <div className='tables'>
              {printMyTables()}
            </div>
          </TabContent>
        </ThinkContent>
      </ThinkSection>
    );
  };

  const printNoTables = () => {
    const { literals } = props;
    return (
      <NoContentWrapper>
        <div className='nocontent'>
          <img src={NoThinkChatsImg} alt='' />
          <div className='text'>{literals.noContent}</div>
          <div className='text'>{literals.noContentSub}</div>
        </div>
      </NoContentWrapper>
    );
  };

  const printNoContent = () => {
    const {
      literals, app,
    } = props;

    return (
      <ThinkSection color={app.color1}>
        {invitations.length > 0 && (
          <ThinkContent className='section_wrapper'>
            <div className='title_section' dangerouslySetInnerHTML={{ __html: literals.yourInvitations }} />
            <TabContent>
              {printInvitations()}
            </TabContent>
          </ThinkContent>)
        }
        <ThinkContent className='section_wrapper'>
          <div className='title_section' dangerouslySetInnerHTML={{ __html: literals.ongoingChats }} />
          <TabContent flex>
            <div className='tables'>
              {printNoTables()}
            </div>
          </TabContent>
        </ThinkContent>
      </ThinkSection>
    );
  };

  const { myThinkChatsList } = props;

  return (
    <div>
      {myThinkChatsList.length > 0 ? printContent() : printNoContent()}
      <div style={{ height: '7vh' }} />
    </div>
  );
}

Think.propTypes = {
  history: PropTypes.object.isRequired,
  app: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  literals: PropTypes.object.isRequired,
  setBreadcrumb: PropTypes.func.isRequired,
  resetContext: PropTypes.func.isRequired,
  myThinkChatsList: PropTypes.array,
  myThinkChatsStatus: PropTypes.string,
  myThinkTanksList: PropTypes.array,
  myThinkTanksStatus: PropTypes.string,
  getInvitations: PropTypes.func.isRequired,
  setSectionSelected: PropTypes.func.isRequired,
  invitations: PropTypes.array,
  resetAll: PropTypes.func.isRequired,
  requestsJoinThinkTank: PropTypes.array,
};

Think.defaultProps = {
  myThinkChatsList: null,
  myThinkChatsStatus: null,
  myThinkTanksList: null,
  myThinkTanksStatus: null,
  invitations: null,
  requestsJoinThinkTank: [],
};

export default Think;



// WEBPACK FOOTER //
// ./src/routes/Think/components/index.jsx